import React, {ReactNode} from 'react';
import FocusTrap from 'focus-trap-react';

export interface BaseModalProps {
  modalClass: string;
  children: ReactNode;
}

function Modal({modalClass, children}: BaseModalProps): JSX.Element {
  return (
    <FocusTrap focusTrapOptions={{escapeDeactivates: false}}>
      <div
        tabIndex={-1}
        role="dialog"
        aria-modal
        className={modalClass}
      >
        {children}
      </div>
    </FocusTrap>
  );
}

export default Modal;
